"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLocalizedNames = exports.getNameLocalizationOrder = exports.NameLocalizationOrder = void 0;
var __1 = require("..");
var language_1 = require("../utils/language");
/*
 * western name order: <first name> <last name>
 * eastern name order: <last name> <first name>
 */
var NameLocalizationOrder;
(function (NameLocalizationOrder) {
    NameLocalizationOrder[NameLocalizationOrder["Western"] = 0] = "Western";
    NameLocalizationOrder[NameLocalizationOrder["Eastern"] = 1] = "Eastern";
})(NameLocalizationOrder = exports.NameLocalizationOrder || (exports.NameLocalizationOrder = {}));
var easternNameLocalizationOrder = {
    languages: new Set(['ja', 'km', 'ko', 'mn', 'hu', 'vi', 'zh']),
};
var getNameLocalizationOrder = function (locale) {
    var language = (0, language_1.getLanguage)(locale);
    return easternNameLocalizationOrder.languages.has(language)
        ? NameLocalizationOrder.Eastern
        : NameLocalizationOrder.Western;
};
exports.getNameLocalizationOrder = getNameLocalizationOrder;
function getJapaneseLocalizedName(userInfo) {
    var SAN = 'さん';
    var SAMA = '様';
    var informalName = ("" + userInfo.familyName + SAN).trim();
    var formalName = ("" + userInfo.familyName + userInfo.givenName + SAMA).trim();
    var formalNameAbbreviated = ("" + userInfo.familyName + SAMA).trim();
    return {
        informalName: informalName,
        formalName: formalName,
        formalNameAbbreviated: formalNameAbbreviated,
    };
}
function getDefaultLocalizedName(userInfo) {
    var informalName = userInfo.givenName;
    var formalName = (userInfo.givenName + " " + userInfo.familyName).trim();
    var formalNameAbbreviated = (userInfo.givenName + " " + (userInfo.familyName.length > 0 ? userInfo.familyName[0] : '')).trim();
    return {
        informalName: informalName,
        formalName: formalName,
        formalNameAbbreviated: formalNameAbbreviated,
    };
}
function getLocalizedNames(userInfo, userLocale) {
    switch (userLocale) {
        case __1.Locale.JA_JP:
        case __1.Locale.JA: {
            return getJapaneseLocalizedName({
                givenName: userInfo.givenName.trim(),
                familyName: userInfo.familyName.trim(),
            });
        }
        default: {
            return getDefaultLocalizedName({
                givenName: userInfo.givenName.trim(),
                familyName: userInfo.familyName.trim(),
            });
        }
    }
}
exports.getLocalizedNames = getLocalizedNames;
